export default "__VITE_ASSET__e528851f__"